export const COUNTRIES = 'countries';
export const SIZES = 'sizes';
export const PARTNER = 'partner';
export const TYPE = 'type';

export const TYPES = 'types';
export const NAME = 'name';
export const ACCOUNT = 'account';
export const CAMPAIGNS = 'campaigns';
export const MULTIPLY_OPTIONS = 'multipleOptions';
